module.exports = __webpack_public_path__ + "img/androidApp.f4645577.png";